<ng-container>
  <div class="favorites-actions-dropdown" [class.favorites-menu-dropdown--collapsed]="collapsed()">
    @if (favorites()?.length ?? 0 > 0) {
      @if (displayMode() === 'OVERLAY') {
        <ftr-icon
          icon="ChevronRight"
          size="Small"
          align="Middle"
          class="court-system-dropdown__icon"
          (click)="dropDownOpened.emit(menuSideNavItems())"
        ></ftr-icon>
      } @else {
        <button
          ftrButton
          [color]="'grey'"
          class="favorites-actions-dropdown__opener"
          [class.favorites-actions-dropdown__opener--collapsed]="collapsed()"
          [class.favorites-actions-dropdown__opener--active]="popover.isOpen()"
          aria-label="Favorites actions"
          ftrTooltip
          message="Favorites actions"
          [showDash]="false"
          position="right"
          [ngbPopover]="menuTemplate"
          #popover="ngbPopover"
          placement="bottom-start"
          container="body"
          [animation]="false"
          popoverClass="favorites-popover"
        >
          <ftr-icon align="Sub" size="Small" icon="MoreHorizontal"></ftr-icon>
        </button>
      }
    } @else {
      <button
        ftrButton
        [color]="'grey'"
        class="favorites-actions-dropdown__opener"
        aria-label="Favorite this page"
        ftrTooltip
        message="Favorite this page"
        [showDash]="false"
        [position]="collapsed() ? 'right' : 'above'"
        (click)="addFavoriteAction()"
      >
        <ftr-icon align="Sub" size="Small" icon="Add"></ftr-icon>
      </button>
    }
  </div>
</ng-container>
<ng-template #menuTemplate>
  <ftr-menu [menuItems]="menuItems" cdkTrapFocus cdkTrapFocusAutoCapture="true"></ftr-menu>
</ng-template>
